import React, { useState } from 'react';
import Input from '../../core/Input/Input';
import Button from '../../core/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { updateCart, removeFromCart } from './../../store/cart/cart.actions';
import { Pedclid } from '../../classes/pedido';
import { toastr } from 'react-redux-toastr';
import './QtySelector.scss';

interface IQtySelector {
    codart: string,
    price: number,
    isCheckout?: boolean,
    desart?: string,
    addOnEnter?: boolean,
    coef: number
};

const QtySelector: React.FC<IQtySelector> = ({ desart = '', codart = '', price = 0, isCheckout = false, addOnEnter, coef = 0 }) => {
    const cart: Pedclid[] = useSelector((state: any) => state.cartStore.cart);
    const articuloInCart: Pedclid|undefined = cart.find((pd: Pedclid) => pd.CODART === codart);
    const [ productQty, setProductQty ] = useState<any>(isCheckout ? articuloInCart?.CANT_PED : articuloInCart?.CANT_PED || 1);
    const dispatch = useDispatch();

    const addToCart = ({ qty = 0 } = {}) => {
        const qtyToUse: number = isCheckout ? qty : productQty;
        const pedclid: Pedclid = new Pedclid(-1, codart, qtyToUse, price, desart, price, coef);
        dispatch(updateCart(pedclid));
    };

    const onQtyChange = (evt: any = {}): void => {
        const value = evt.target.value;

        let qty = value.toString().replace(',', '.');
        
        if (qty !== '') {
            qty = parseFloat(qty);
        }

        setProductQty(qty);

        if (isCheckout) {
            addToCart({ qty });
        }
    }

    const remove = () => {
        dispatch(removeFromCart(codart));
        setProductQty(1);
        toastr.error(`${desart} se ha quitado del carrito`, `El producto se ha eliminado del carrito.`);
    }

    const renderButtons = () => {
        if (!isCheckout) {            
            return (
                <>
                    <Button 
                        click={addToCart}
                        className="AddBtn">{articuloInCart ? 'MODIFICAR' : 'AGREGAR'}
                    </Button>
                    {articuloInCart ? <Button click={remove} className="RemoveBtn">QUITAR</Button> : null}
                </>
            );
        }
    }

    const onKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            addToCart();
            blurKeyboard(event);
        }
    };

    const blurKeyboard = (event: any) => {
        if (event.key === 'Enter') event.target.blur();
    };
    
    return (
        <div className="QtySelector">
            <Input 
                id={codart}
                className="QtyInput"
                type="number" 
                value={productQty} 
                minLength={1}
                disabled={false}
                keyPress={addOnEnter ? onKeyPress : blurKeyboard}
                change={onQtyChange}
            />

            {renderButtons()}
        </div>
    );
};

export default QtySelector;